export const colors = {
  'action-blue': '#0063c6',
  'promo-dark-blue': '#002966',
  'black-faded': '#000000e6',
  'black-faded-light': '#00000082',
  aqua: '#50c2cc',
  'mattamy-blue': '#0B2C71',
  'light-blue': '#d8e5ed',
  footer: '#292D32',
  'toolbar-blue': '#0063C6',
  'mattamy-gray': '#292C31',
  'mattamy-gray-light': '#8E8E8E',
  'mattamy-gray-bg': '#E6E6E6',
  'border-light-blue': '#B3C3CD',
  'home-details-divider': '#d8dde4',
  'mattamy-blue-dark': '#02468A',
  'mattamy-blue-light': '#0063C7',
  white: '#FFFFFF',
  'without-image': '#808080',
  'dark-gray-bg': '#3B4450',
  'form-field-gray': '#6E7B8E',
  'form-submit-gray': '#D3D3D3',
  'field-error': '#FF0000',
  'mattamy-gray-font': '#757575',
  'menu-video-galley': '#eff0f5',
  'mattamy-search-gray': '#595959',
  'mattamy-search-ligth-gray': '#EDEDED',
  'poi-cluster-color': '#2d68ae',
};
